import { environment } from '../../pages/util/baseUrl';

/**
 * Construye la URL completa para una imagen de producto
 * @param {string} imagePath - La ruta de imagen del backend (ej: /upload/productos/img123.jpg)
 * @returns {string} URL completa para la imagen
 */
export const getImageUrl = (imagePath) => {
    if (!imagePath) {
        return 'https://via.placeholder.com/300x300?text=Sin+Imagen';
    }
    
    // Si ya es una URL completa, devolverla tal cual
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }
    
    // Construir URL usando el backend base
    return `${environment.backendUrl}${imagePath}`;
};

/**
 * Obtiene la URL de imagen desde un objeto producto
 * Valida tanto "imagen" como "image" como "images"
 * @param {object} product - Objeto producto
 * @param {string} fallback - URL por defecto si no hay imagen
 * @returns {string} URL de imagen
 */
export const getProductImageUrl = (product, fallback = 'https://via.placeholder.com/300x300?text=Sin+Imagen') => {
    if (!product) return fallback;
    
    // Intentar obtener imagen de propiedades comunes
    const imagePath = product.imagen || product.image || product.images;
    
    if (!imagePath) return fallback;
    
    // Si es array, tomar el primero
    if (Array.isArray(imagePath)) {
        return imagePath.length > 0 ? getImageUrl(imagePath[0]) : fallback;
    }
    
    return getImageUrl(imagePath);
};
